module.exports = __webpack_public_path__ + "img/partners-icon13.f2bfba3a.jpg";